<template>
  <div>
    <div>
      <v-textarea color="kbDarkBlue"
                  :label="$t('general.insertNewNote')"
                  v-model="note"
                  auto-grow
                  rows="1">
        <template v-slot:append>
          <v-btn color="kbDarkBlue"
                 icon
                 :loading="updatingNotes"
                 @click="addNote()">
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
      </v-textarea>
    </div>

    <div class="grey lighten-3 mb-2"
         style="border-radius: 4px"
         v-for="(item, index) in notes"
         :key="JSON.stringify(item)">
      <Note :index="index"
            :item="item"
            @remove="removeNote(index)"
            @update="updateNote(index, $event)">
      </Note>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Note from '@/pages/App/Conversations/components/Note.vue'
import notifications from '@/libs/notifications'
export default {
  components: { Note },
  computed: {
    ...mapGetters(['userNotes']),
    ...mapState({
      userKeybe: state => state.auth.userKeybe,
      user: state => state.conversations.user
    })
  },
  created () {
    this.notes = [...this.userNotes]
  },
  data: () => ({
    note: '',
    notes: [],
    noteDate: new Date().toISOString().substr(0, 10),
    noteHour: new Date().getHours() + ':' + new Date().getMinutes(),
    updatingNotes: false
  }),
  methods: {
    addNote () {
      if (this.note.trim()) {
        const existingNote = this.notes.find(
          note => note.value.toLowerCase() === this.note.toLowerCase()
        )

        if (existingNote === undefined) {
          this.notes.unshift({
            value: this.note,
            date: this.noteDate,
            hour: this.noteHour,
            user: {
              UUID: this.user.UUID,
              name: this.userKeybe.name || '',
              email: this.userKeybe.email || ''
            }
          })
          this.updateNotes()
        }
      }
      this.note = ''
    },
    findEditedNote (index, editValue) {
      this.notes[index].value = editValue
      this.updateNotes()
    },
    removeNote (index) {
      this.notes.splice(index, 1)
      this.updateNotes()
    },
    resetValues () {
      this.updatingNotes = false
      this.noteDate = new Date().toISOString().substr(0, 10)
      this.noteHour = new Date().getHours() + ':' + new Date().getMinutes()
    },
    updateNote (index, value) {
      this.notes[index].value = value
      this.updateNotes()
    },
    async updateNotes () {
      this.updatingNotes = true
      const extraData = []

      extraData.push({
        field: 'userNotesModule',
        value: this.notes
      })

      try {
        await this.$store.dispatch('updateUser', {
          userId: this.user.userId,
          extraData
        })

        this.resetValues()
      } catch (e) {
        notifications.error(this.$t('general.errorUpdatingNotes'))
        this.resetValues()
        throw e
      }
    }
  },
  props: {
    mainColor: {
      type: String
    }
  },
  watch: {
    userNotes (value) {
      this.notes = [...value]
    }
  }
}
</script>
